export default "__VITE_PUBLIC_ASSET__5a64288d__"